import { useEffect, useState } from "react";
import { filterConstants } from "../../constants";

import { fraudAndRiskLevel, transactionStatus } from "../../enums";
import { useQueryString } from "../../hooks";
import {
  ITransactionBase,
  IQueryStringNavLinks,
  ITableHeader,
  ITransaction,
} from "../../interfaces-and-types";
import { transactionsData } from "../../test-data";
import { View } from "./View";

export interface IFraudsAndRisksViewProps {
  data: ITransactionBase[];
  headers: ITableHeader[];
  isLoading: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // extra buttons
  onExport: () => void;
}

export const FraudsAndRisks = () => {
  const [isLoading, setisLoading] = useState(true);

  // const query = useQueryString();

  useEffect(() => {
    setTimeout(() => setisLoading(false), 500);
  }, []);

  const headers: ITableHeader[] = [
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "fraudAndRiskLevel",
      header: "Risk Level",
    },
    {
      key: "description",
      header: "Description",
    },
    {
      key: "customer",
      header: "Customer",
    },
    {
      key: "ipAddress",
      header: "Device",
    },
    {
      key: "gateway",
      header: "Gateway",
    },
    {
      key: "date",
      header: "Date",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "Reviews",
        value: "reviews",
      },
      {
        key: "Disputes",
        value: "disputes",
      },
    ],
  };

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };

  return (
    <View
      data={transactionsData}
      headers={headers}
      isLoading={isLoading}
      totalCount={transactionsData.length}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
    />
  );
};
